import { gql } from '@apollo/client';

export default gql`
  query getCombinedShiftReport(
    $startDate: String!
    $endDate: String!
    $username: String!
    $organizationCode: String!
    $officeCode: String!
    $shouldUseByPeriod: Boolean = false
  ) {
    getCombinedShiftReport(
      startDate: $startDate
      endDate: $endDate
      username: $username
      organizationCode: $organizationCode
      officeCode: $officeCode
      shouldUseByPeriod: $shouldUseByPeriod
    ) {
      totalNumberOfTransactions {
        GBP
        EUR
        USD
      }
      transactionSummaries {
        type
        totalNumberOfTransactions
        totalAmountInEuros
        totalAmountInPounds
        totalAmountInDollars
      }
      transactions {
        pnr
        currency
        amount
        method
        reference
        refundProcessTimestamp
        status
        display @client
        firstDate
        firstDepartureStationName
        firstDepartureStationShortCode
        firstArrivalStationName
        firstArrivalStationShortCode
        date
        time
      }
      freeTransactions {
        pnr
        currency
        amount
        method
        reference
        refundProcessTimestamp
        status
        display @client
        firstDate
        firstDepartureStationName
        firstDepartureStationShortCode
        firstArrivalStationName
        firstArrivalStationShortCode
        date
        time
      }
    }
  }
`;
